var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 7.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21402_55385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4438 9.6109C12.5854 9.61106 12.7216 9.66528 12.8246 9.76248C12.9276 9.85969 12.9895 9.99254 12.9978 10.1339C13.0061 10.2753 12.9601 10.4144 12.8692 10.523C12.7784 10.6316 12.6494 10.7014 12.5088 10.7181L12.4438 10.722H4.89605L6.16994 11.9959C6.26958 12.0959 6.32743 12.23 6.33173 12.3711C6.33604 12.5122 6.28649 12.6496 6.19314 12.7555C6.09978 12.8614 5.96963 12.9277 5.82912 12.9411C5.68861 12.9545 5.54827 12.9139 5.43661 12.8276L5.38438 12.7815L3.25661 10.6537C2.88716 10.2848 3.12383 9.66312 3.62494 9.61423L3.68883 9.6109H12.4438ZM9.82883 4.21812C9.92449 4.12247 10.0518 4.06501 10.1868 4.05652C10.3218 4.04803 10.4553 4.08909 10.5622 4.17201L10.6144 4.21812L12.7422 6.3459C13.1116 6.71479 12.8749 7.33645 12.3738 7.38534L12.3099 7.38868H3.55494C3.41334 7.38852 3.27714 7.3343 3.17418 7.23709C3.07122 7.13989 3.00925 7.00704 3.00096 6.86568C2.99266 6.72432 3.03865 6.58513 3.12953 6.47655C3.22042 6.36796 3.34933 6.29818 3.48994 6.28145L3.55494 6.27757H11.1027L9.82883 5.00368C9.72468 4.89949 9.66617 4.75821 9.66617 4.6109C9.66617 4.46358 9.72468 4.3223 9.82883 4.21812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21402_55385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(1.33301 1.83325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIconWhite);
export default __webpack_public_path__ + "static/media/transfer-icon-white.5b72b7e628131f90e43eb162f7b2c9d0.svg";
export { ForwardRef as ReactComponent };